import React from 'react';

import Teaser from '../../../../components/Teaser';

import './style.scss';

const NodeArticleTeaser = ({ entity, large, labeled, lazyload }) => {

  return (
    <div className="BaseTeaser NodeArticleTeaser">
      <Teaser
        entity={entity}
        large={large}
        labeled={labeled}
        type="article"
        showDate
        lazyload={lazyload}
      />
    </div>
  );
};

export default NodeArticleTeaser;
